// Notification
import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

class Toast {
    constructor(){
        // Use toast
        this.toast = useToast()
    }

    toastAddEvent = msg =>{
        this.toast({
            component: ToastificationContent,
            props: {
                title: `新增 ${msg}`,
                icon: 'CheckCircleIcon',
                variant: 'success',
            },
        })
    }

    toastDeleteEvent = msg => {
        this.toast({
            component: ToastificationContent,
            props: {
                title: `刪除 ${msg}`,
                icon: 'TrashIcon',
                variant: 'danger',
            },
        })
    }
    
    toastUpdateEvent = msg =>{
        this.toast({
            component: ToastificationContent,
            props: {
                title: `修改 ${msg}`,
                icon: 'CheckIcon',
                variant: 'success',
            },
        })
    }

    toastError = msg => {
        this.toast({
            component: ToastificationContent,
            props: {
                title: `${msg}`,
                icon: 'AlertTriangleIcon',
                variant: 'danger',
            },
        })
    }

    toastSuccess = msg => {
        this.toast({
            component: ToastificationContent,
            props: {
                title: `${msg}`,
                icon: 'CheckCircleIcon',
                variant: 'success',
            },
        })
    }

    toastUpdate = msg =>{
        this.toast({
            component: ToastificationContent,
            props: {
                title: `${msg}`,
                icon: 'CheckIcon',
                variant: 'warning',
            },
        })
    }
}

export default Toast